<template>
  <div>
    <v-autocomplete
      v-model="ticket.cliente"
      label="Documento"
      :items="loadFilteredClientes(ticket.crianca)"
      item-value="id"
      item-text="documento"
      @change="[selectClient(ticket.cliente), checkTickets()]"
      :loading="loading"
      :search-input.sync="searchDocumento"
      hide-no-data
    />
    <v-autocomplete
      v-model="ticket.cliente"
      label="Cliente"
      :items="loadFilteredClientes(ticket.crianca)"
      item-value="id"
      item-text="nome"
      append-outer-icon="mdi-account-plus-outline"
      @click:append-outer="
        openNewClientModal(false, ticket.crianca ? 'C' : null)
      "
      @change="[selectClient(ticket.cliente), checkTickets()]"
      :loading="loading"
      :search-input.sync="searchNome"
      hide-no-data
    />

    <v-dialog v-model="showAgeWarningDialog" persistent width="500px" style="z-index: 1000;">
      <v-card>
        <v-card-title class="error white--text d-flex justify-space-between">
          <span>Aviso de Idade</span>
        </v-card-title>
        <v-card-text class="pt-7 px-5 text-center">
          <p class="subtitle-1" v-if="childInfo.age !== null">
            O passageiro nascido em
            <strong>{{ childInfo.birthDate }}</strong> tem
            <strong>{{ childInfo.age }} anos</strong>.
            <br />
            <strong>É obrigatório o pagamento da passagem.</strong>
          </p>
        </v-card-text>
        <v-card-actions class="d-flex justify-end px-5">
          <v-btn depressed text @click="showAgeWarningDialog = false" class="primary--text">
            Entendido
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialog" persistent width="600px" style="z-index: 1010;">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        autocomplete="off"
        @submit.prevent
      >
        <v-card>
          <v-card-title
            class="primary white--text d-flex justify-space-between"
          >
            <span>Adicionar Data de Nascimento</span>
          </v-card-title>

          <v-card-text class="pt-7 px-7">
            <v-row dense class="px-1">
              <p>
                <strong>
                  Devido às novas regras da ANTT, a data de nascimento do
                  passageiro tornou-se um requisito obrigatório para a venda da
                  passagem.
                </strong>
              </p>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <span class="primary--text">Data de Nascimento*</span>
                <v-text-field
                  v-model="data_nascimento"
                  placeholder="Informe a data de nascimento"
                  class="mt-n1"
                  :rules="dataRules"
                  v-mask-date.br
                  required
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="d-flex justify-end px-5">
            <v-btn depressed text :disabled="!valid" @click="validate">
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="showDialog2" persistent width="600px" style="z-index: 1020;">
      <v-form
        ref="form2"
        v-model="valid2"
        lazy-validation
        autocomplete="off"
        @submit.prevent
      >
        <v-card>
          <v-card-title
            class="primary white--text d-flex justify-space-between"
          >
            <span>Corrigir Nome do Passageiro</span>
          </v-card-title>

          <v-card-text class="pt-7 px-7">
            <v-row dense class="px-1">
              <p>
                <strong>
                  Devido às novas regras da ANTT, o nome completo do passageiro tornou-se um requisito obrigatório para a venda da passagem.
                </strong>
              </p>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <span class="primary--text">Nome Completo*</span>
                <v-text-field
                  v-model="nome_completo"
                  placeholder="Informe o nome completo"
                  class="mt-n1 uppercase-text"
                  :rules="nameRules"
                  required
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="d-flex justify-end px-5">
            <v-btn depressed text :disabled="!valid2" @click="validate2">
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["ticket"],
  data: () => ({
    clients: [],
    loading: false,
    searchDocumento: null,
    searchNome: null,
    showDialog: false,
    showDialog2: false,
    showAgeWarningDialog: false,
    childInfo: {
      birthDate: null,
      age: null,
    },
    valid: true,
    valid2: true,
    data_nascimento: "",
    nome_completo: "",
    clientSelected: null,
    dataRules: [
      (v) => !!v || "Este campo é requerido",
      (v) =>
        /^\d{2}\/\d{2}\/\d{4}$/.test(v) ||
        "Insira uma data válida no formato DD/MM/AAAA!",
      (v) => {
        const [dia, mes, ano] = v.split("/").map(Number);
        const data = new Date(ano, mes - 1, dia);

        // Verifica se a data é válida
        if (
          data.getDate() !== dia ||
          data.getMonth() !== mes - 1 ||
          data.getFullYear() !== ano
        ) {
          return "Insira uma data válida!";
        }

        // Verifica se a data não é no futuro
        const hoje = new Date();
        if (data > hoje) {
          return "A data não pode ser no futuro!";
        }

        return true;
      },
    ],
    nameRules: [
      (v) => !!v || 'Este campo é obrigatório',
      (v) => /^[A-Za-zÀ-ÿ\s]+$/.test(v) || 'Use apenas letras, sem números ou caracteres especiais',
      (v) => !/\s{2,}/.test(v) || 'Não utilize espaços seguidos',
      (v) => v.trim().split(' ').length >= 2 || 'Informe pelo menos nome e sobrenome',
    ],
    message: {
      snacshow: false,
      text: "",
      type: "",
      mode: "",
      timeout: 2000,
    },
  }),
  watch: {
    searchDocumento(val) {
      if (!val || val.length < 3) {
        this.clients = [];
        return;
      }

      this.loading = true;
      this.querySelections(val);
    },
    searchNome(val) {
      if (!val || val.length < 3) {
        this.clients = [];
        return;
      }

      this.loading = true;
      this.querySelections(val);
    },
  },
  methods: {
    calculateAge(birthDateString) {
      // Converte a data de DD/MM/AAAA ou YYYY-MM-DD para um objeto Date
      let birthDate;
      if (birthDateString.includes("/")) {
        const parts = birthDateString.split("/");
        birthDate = new Date(+parts[2], parts[1] - 1, +parts[0]);
      } else {
        const parts = birthDateString.split("-");
        birthDate = new Date(+parts[0], parts[1] - 1, +parts[2]);
      }

      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    checkChildAge(birthDate) {
      if (!this.ticket.crianca) return;

      const age = this.calculateAge(birthDate);
      if (age >= 6) {
        let formattedBirthDate;
        if (birthDate.includes("/")) {
          formattedBirthDate = birthDate;
        } else {
          const parts = birthDate.split("-");
          formattedBirthDate = `${parts[2]}/${parts[1]}/${parts[0]}`;
        }
        this.childInfo = {
          birthDate: formattedBirthDate,
          age: age,
        };
        this.showAgeWarningDialog = true;
      }
    },
    loadFilteredClientes(crianca) {
      if (!this.clients) return [];
      return crianca
        ? this.clients.filter((client) => client.tipo === "C")
        : this.clients.filter((client) => client.tipo !== "C");
    },
    isValidFullName(name) {
      if (!name) return false;

      const value = name.trim();

      // obrigatório
      if (!value) return false;

      // somente letras e espaços
      if (!/^[A-Za-zÀ-ÿ\s]+$/.test(value)) return false;

      // não permitir espaços seguidos
      if (/\s{2,}/.test(value)) return false;

      // pelo menos dois nomes
      if (value.split(' ').length < 2) return false;

      return true;
    },
    async selectClient(clientId) {
      const response = await this.$http.get(`/clientes/${clientId}`);

      if (response.data.length > 0) {
        this.clientSelected = response.data[0];
      } else {
        this.clientSelected = this.clients.find((value) => value.id == clientId);
      }

      if (!this.isValidFullName(this.clientSelected.nome)) {
        this.nome_completo = this.clientSelected.nome;
        this.showDialog2 = true;
      }

      if (!this.clientSelected.data_nascimento) {
        this.showDialog = true;
      } else {
        let dataNascimento, dia, mes, ano;

        if (this.clientSelected.data_nascimento.includes("/")) {
          const parts = this.clientSelected.data_nascimento.split("/");
          dataNascimento = new Date(+parts[2], parts[1] - 1, +parts[0]);
          dia = +parts[0];
          mes = +parts[1];
          ano = +parts[2];
        } else {
          const parts = this.clientSelected.data_nascimento.split("-");
          dataNascimento = new Date(+parts[0], parts[1] - 1, +parts[2]);
          dia = +parts[2];
          mes = +parts[1];
          ano = +parts[0];
        }

        if (
          dataNascimento.getDate() !== dia ||
          dataNascimento.getMonth() !== mes - 1 ||
          dataNascimento.getFullYear() !== ano
        ) {
          this.showDialog = true;
        } else {
          this.checkChildAge(this.clientSelected.data_nascimento);
        }
      }

      this.$emit("selectClient", clientId);
    },
    checkTickets() {
      this.$emit("checkTickets");
    },
    openNewClientModal(show = false, type = null) {
      this.$emit("openNewClientModal", show, type);
    },
    querySelections(v) {
      clearTimeout(this._searchTimerId);
      this._searchTimerId = setTimeout(() => {
        this.$http
          .get(`/clientes/search/${v}`)
          .then((r) => {
            this.clients = r.data;
          })
          .finally(() => (this.loading = false));
      }, 500);
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("activeLoader", true);

        this.$http
          .post(`/clientes/update/${this.clientSelected.id}`, {
            data_nascimento: this.data_nascimento,
          })
          .then((r) => {
            this.$store.dispatch("activeLoader", false);
            if (r.data.success) {
              this.message.text = "Atualizado com Sucesso!";
              this.message.snacshow = true;
              this.message.type = "success";
              this.checkChildAge(this.data_nascimento); // Verifica a idade após atualizar
              this.data_nascimento = "";
              this.showDialog = false;
            } else {
              this.$store.dispatch("activeLoader", false);
              this.message.text = "Falha ao atualizar";
              this.message.snacshow = true;
              this.message.type = "warning";
            }
          })
          .catch((e) => {
            console.log(e);
            this.$store.dispatch("activeLoader", false);
            this.message.text = "Falha ao atualizar";
            this.message.snacshow = true;
            this.message.type = "success";
          });
      } else {
        this.message.snacshow = true;
        this.message.type = "warning";
        this.message.text =
          "Atenção: Informa a data de nascimento para continuar.";
      }
    },
    validate2() {
      if (this.$refs.form2.validate()) {
        this.$store.dispatch("activeLoader", true);

        this.$http
          .post(`/clientes/update/${this.clientSelected.id}`, {
            nome: this.nome_completo.toUpperCase().trim()
          })
          .then((r) => {
            this.$store.dispatch("activeLoader", false);
            if (r.data.success) {
              this.message.text = "Atualizado com Sucesso!";
              this.message.snacshow = true;
              this.message.type = "success";
              this.querySelections(this.nome_completo);
              this.nome_completo = "";
              this.showDialog2 = false;
            } else {
              this.$store.dispatch("activeLoader", false);
              this.message.text = "Falha ao atualizar";
              this.message.snacshow = true;
              this.message.type = "warning";
            }
          })
          .catch((e) => {
            console.log(e);
            this.$store.dispatch("activeLoader", false);
            this.message.text = "Falha ao atualizar";
            this.message.snacshow = true;
            this.message.type = "success";
          });
      } else {
        this.message.snacshow = true;
        this.message.type = "warning";
        this.message.text = "Atenção: Informe o nome completo para continuar.";
      }
    }
  },
};
</script>
